(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-featured-press';

  function initCarousel(section) {
    var carousel = section.querySelector('[data-press-carousel]');
    if (!carousel) return null;

    var viewport = carousel.querySelector('[data-press-viewport]');
    var track = carousel.querySelector('[data-press-track]');
    var prevBtn = carousel.querySelector('[data-press-prev]');
    var nextBtn = carousel.querySelector('[data-press-next]');
    var dotsContainer = carousel.querySelector('[data-press-dots]');
    var realItems = Array.prototype.slice.call(track.querySelectorAll('.oddit-section-featured-press__item'));
    var heading = section.querySelector('[data-press-heading]');

    if (!viewport || !track || realItems.length === 0) return null;

    var realCount = realItems.length;
    var realBtns = realItems.map(function (li) {
      return li.querySelector('[data-press-item]');
    });

    // BEB-88: endless looping. Clone the full logo set before and after the real
    // logos so the centred (active) logo always has neighbours on both sides —
    // removing the empty gap / lopsided look at the first and last slide.
    //
    // The gap only shows in the desktop "transform strip" layout, so the clones
    // are revealed by CSS at >=990px and hidden below it; on mobile/tablet the
    // track still free-scrolls the real logos with their edge spacers, and the
    // loop just wraps the index. Gated behind the carousel's data-press-loop flag
    // (set from the section setting) so it can be switched off from the editor.
    var LOOP = carousel.hasAttribute('data-press-loop') && realCount > 1;

    // Tag the first/last *real* logo so the mobile edge spacers still land on
    // them once clones become the literal first/last DOM children.
    realItems[0].classList.add('oddit-section-featured-press__item--first-real');
    realItems[realCount - 1].classList.add('oddit-section-featured-press__item--last-real');

    if (LOOP) {
      var head = document.createDocumentFragment();
      var tail = document.createDocumentFragment();
      realItems.forEach(function (li) {
        [li.cloneNode(true), li.cloneNode(true)].forEach(function (clone, n) {
          clone.setAttribute('data-press-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.remove('oddit-section-featured-press__item--first-real');
          clone.classList.remove('oddit-section-featured-press__item--last-real');
          var btn = clone.querySelector('[data-press-item]');
          if (btn) btn.setAttribute('tabindex', '-1');
          (n === 0 ? head : tail).appendChild(clone);
        });
      });
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
    }

    var allItems = Array.prototype.slice.call(track.querySelectorAll('.oddit-section-featured-press__item'));
    var allBtns = allItems.map(function (li) {
      return li.querySelector('[data-press-item]');
    });

    // Real logo i lives at allItems[domOffset + i] once clones are prepended.
    var domOffset = LOOP ? realCount : 0;
    var totalSlides = realCount;

    // Build one dot per real logo so pagination reflects the real count only.
    var dots = [];
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var d = 0; d < totalSlides; d++) {
        var dotBtn = document.createElement('button');
        dotBtn.type = 'button';
        dotBtn.className = 'oddit-section-featured-press__dot';
        dotBtn.setAttribute('data-press-dot', String(d));
        dotBtn.setAttribute('role', 'tab');
        dotBtn.setAttribute('aria-label', 'Go to slide ' + (d + 1));
        var dotInner = document.createElement('span');
        dotInner.setAttribute('aria-hidden', 'true');
        dotInner.innerHTML = '&zwnj;';
        dotBtn.appendChild(dotInner);
        dotsContainer.appendChild(dotBtn);
        dots.push(dotBtn);
      }
    }
    var dotCount = dots.length;

    var currentIndex = 0;       // real index (0..realCount-1) — drives dots/quote
    var domIndex = domOffset;   // position in allItems currently centred

    var AUTOPLAY_MS = 5000;
    var HEADING_FADE_MS = 280;
    var SNAP_MS = 520; // slightly longer than the 0.45s slide transition
    var prefersReducedMotion = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var autoplayId = null;
    var autoplayStopped = false;
    var programmaticScroll = false;
    var programmaticScrollTimer = null;
    var currentTranslate = 0; // BEB-82: desktop translateX offset of the strip
    var snapTimer = null;
    var headingFadeTimer = null;
    var currentQuote = heading ? heading.textContent : '';

    function realFromDom(d) {
      return ((d - domOffset) % realCount + realCount) % realCount;
    }

    function isScrollMode() {
      var overflowX = '';
      try { overflowX = window.getComputedStyle(track).overflowX; } catch (e) {}
      return overflowX === 'auto' || overflowX === 'scroll';
    }

    function setHeadingQuote(quote) {
      if (!heading || !quote || quote === currentQuote) return;
      currentQuote = quote;
      if (prefersReducedMotion) {
        heading.textContent = quote;
        return;
      }
      if (headingFadeTimer !== null) clearTimeout(headingFadeTimer);
      heading.classList.add('is-fading');
      headingFadeTimer = setTimeout(function () {
        heading.textContent = quote;
        // Force reflow so the removal of the class re-triggers the transition.
        void heading.offsetWidth;
        heading.classList.remove('is-fading');
        headingFadeTimer = null;
      }, HEADING_FADE_MS);
    }

    function updateDots() {
      if (dotCount === 0) return;
      dots.forEach(function (dot, i) {
        var isActive = i === currentIndex;
        dot.classList.toggle('oddit-section-featured-press__dot--active', isActive);
        if (isActive) {
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.removeAttribute('aria-selected');
        }
      });
    }

    function updateNavState() {
      // With looping enabled the carousel never reaches a hard edge.
      if (LOOP) {
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
        return;
      }
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - 1;
    }

    function updateActive() {
      // The centred element is the active one — works for a real logo or, mid-loop,
      // a clone (which is a pixel-identical copy of the same logo).
      allBtns.forEach(function (btn, i) {
        if (!btn) return;
        btn.classList.toggle(
          'oddit-section-featured-press__item-btn--active',
          i === domIndex
        );
      });
      if (heading) {
        var activeBtn = allBtns[domIndex];
        var quote = activeBtn && activeBtn.getAttribute('data-press-quote');
        if (quote) setHeadingQuote(quote);
      }
    }

    function measureHeadingHeight() {
      if (!heading) return;
      var quotes = realBtns
        .map(function (b) { return b && b.getAttribute('data-press-quote'); })
        .filter(Boolean);
      if (quotes.length === 0) return;
      var saved = heading.textContent;
      // Clear the reservation, then render each quote and keep the tallest.
      heading.style.minHeight = '';
      var max = 0;
      quotes.forEach(function (q) {
        heading.textContent = q;
        if (heading.offsetHeight > max) max = heading.offsetHeight;
      });
      heading.textContent = saved;
      heading.style.minHeight = max + 'px';
    }

    var measureTimer = null;
    function scheduleMeasure() {
      if (measureTimer !== null) clearTimeout(measureTimer);
      measureTimer = setTimeout(function () {
        measureTimer = null;
        measureHeadingHeight();
      }, 150);
    }

    // BEB-82/88: centre allItems[domIndex] in the viewport.
    //  - Mobile/tablet: the track is a horizontal scroll container, so we set
    //    scrollLeft (clamped to the scrollable range). Clones are hidden here so
    //    domIndex always points at a real, scrollable logo.
    //  - Desktop: the track is a slid strip moved with translateX, so the active
    //    logo (real or clone) can be brought all the way to the centre.
    function centerActiveItem(behavior) {
      var item = allItems[domIndex];
      if (!item) return;

      if (isScrollMode()) {
        // Drop any transform left over from a wider breakpoint.
        if (currentTranslate !== 0) {
          currentTranslate = 0;
          track.style.transform = '';
        }
        if (track.scrollWidth <= track.clientWidth) return;
        var offset = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        if (offset < 0) offset = 0;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (offset > maxScroll) offset = maxScroll;
        track.scrollTo({ left: offset, behavior: behavior || 'smooth' });
        return;
      }

      // Transform mode: shift the track so the active logo's current centre lands
      // on the viewport centre (works wherever the strip currently sits).
      var itemRect = item.getBoundingClientRect();
      var viewportRect = viewport.getBoundingClientRect();
      var delta = (viewportRect.left + viewportRect.width / 2) -
        (itemRect.left + itemRect.width / 2);
      if (Math.abs(delta) < 0.5) return;
      currentTranslate += delta;
      if (behavior === 'auto') {
        var prevTransition = track.style.transition;
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
        void track.offsetWidth; // commit, then restore for animated moves
        track.style.transition = prevTransition || '';
      } else {
        track.style.transform = 'translateX(' + currentTranslate + 'px)';
      }
    }

    function applyState() {
      currentIndex = realFromDom(domIndex);
      updateDots();
      updateNavState();
      updateActive();
    }

    function lockProgrammatic() {
      // Lock scroll-driven sync while the smooth programmatic move settles, so
      // the heading doesn't flicker through the in-between quotes.
      programmaticScroll = true;
      if (programmaticScrollTimer !== null) clearTimeout(programmaticScrollTimer);
      programmaticScrollTimer = setTimeout(function () {
        programmaticScroll = false;
        programmaticScrollTimer = null;
      }, 700);
    }

    // BEB-88: after a loop step lands on a clone, silently rebase domIndex onto
    // the equivalent real logo (an instant, invisible jump — same logo, same
    // pixel position) so the strip can keep sliding the same direction forever.
    function scheduleSnap() {
      if (!LOOP) return;
      if (snapTimer !== null) clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        snapTimer = null;
        if (isScrollMode()) return; // scroll mode keeps domIndex in the real range
        var rebased = false;
        while (domIndex < domOffset) { domIndex += realCount; rebased = true; }
        while (domIndex >= domOffset + realCount) { domIndex -= realCount; rebased = true; }
        if (rebased) {
          centerActiveItem('auto');
          updateActive();
        }
      }, SNAP_MS);
    }

    // Advance/retreat by one logo.
    function step(delta) {
      if (isScrollMode()) {
        // Wrap within the real range; clones stay hidden so we never centre one.
        currentIndex = ((currentIndex + delta) % realCount + realCount) % realCount;
        domIndex = domOffset + currentIndex;
        lockProgrammatic();
        centerActiveItem('smooth');
        updateDots();
        updateNavState();
        updateActive();
        return;
      }
      domIndex += delta;
      lockProgrammatic();
      centerActiveItem('smooth');
      applyState();
      scheduleSnap();
    }

    // Jump straight to a real logo (dots) — centre its canonical occurrence.
    function goToReal(realIndex) {
      if (realIndex < 0) realIndex = 0;
      if (realIndex > realCount - 1) realIndex = realCount - 1;
      domIndex = domOffset + realIndex;
      lockProgrammatic();
      centerActiveItem('smooth');
      applyState();
    }

    // Centre a specific DOM logo (clicked logo — possibly a clone) in place.
    function goToDom(p) {
      if (p < 0 || p >= allItems.length) return;
      domIndex = p;
      lockProgrammatic();
      centerActiveItem('smooth');
      applyState();
      scheduleSnap();
    }

    function autoplayTick() {
      step(1);
    }

    function startAutoplay() {
      if (autoplayStopped || prefersReducedMotion || totalSlides <= 1) return;
      if (autoplayId !== null) return;
      autoplayId = setInterval(autoplayTick, AUTOPLAY_MS);
    }

    function pauseAutoplay() {
      if (autoplayId !== null) {
        clearInterval(autoplayId);
        autoplayId = null;
      }
    }

    function stopAutoplay() {
      autoplayStopped = true;
      pauseAutoplay();
    }

    // A user interaction shouldn't kill autoplay for good — just reset the
    // countdown so it pauses momentarily, then resumes with a fresh interval.
    function restartAutoplay() {
      pauseAutoplay();
      startAutoplay();
    }

    function handlePrev() {
      restartAutoplay();
      step(-1);
    }

    function handleNext() {
      restartAutoplay();
      step(1);
    }

    function handleItemClick(e) {
      var idx = allBtns.indexOf(e.currentTarget);
      if (idx < 0) return;
      restartAutoplay();
      goToDom(idx);
    }

    function handleDotClick(e) {
      restartAutoplay();
      var dotIndex = parseInt(e.currentTarget.getAttribute('data-press-dot'), 10);
      if (isNaN(dotIndex)) return;
      goToReal(dotIndex);
    }

    function syncIndexFromScroll() {
      // Find the real logo closest to the viewport center (clones are hidden).
      var viewportCenter = track.scrollLeft + viewport.offsetWidth / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;
      realItems.forEach(function (item, i) {
        var itemCenter = item.offsetLeft + item.offsetWidth / 2;
        var distance = Math.abs(itemCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      if (closestIndex !== currentIndex) {
        currentIndex = closestIndex;
        domIndex = domOffset + currentIndex;
        updateDots();
        updateNavState();
        updateActive();
      }
    }

    var scrollRafId = null;
    function handleScroll() {
      if (programmaticScroll) return;
      if (scrollRafId !== null) return;
      scrollRafId = requestAnimationFrame(function () {
        syncIndexFromScroll();
        scrollRafId = null;
      });
    }

    function handleResize() {
      // BEB-82: re-centre on any size change — both the translateX offset
      // (desktop) and scrollLeft (mobile) depend on live measurements.
      centerActiveItem('auto');
    }

    // Wire up events
    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);
    dots.forEach(function (dot) {
      dot.addEventListener('click', handleDotClick);
    });
    allBtns.forEach(function (btn) {
      if (btn) btn.addEventListener('click', handleItemClick);
    });
    carousel.addEventListener('pointerenter', pauseAutoplay);
    carousel.addEventListener('pointerleave', startAutoplay);
    track.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', scheduleMeasure);

    var ro = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(handleResize);
      ro.observe(section);
    }

    // Initialize: start at the middle real slide so the carousel reads as a
    // balanced "in-progress" state.
    if (totalSlides > 1) {
      currentIndex = Math.floor(totalSlides / 2);
    }
    domIndex = domOffset + currentIndex;
    updateDots();
    updateNavState();
    updateActive();
    // Defer initial positioning to next frame so layout is ready.
    requestAnimationFrame(function () {
      centerActiveItem('auto');
      measureHeadingHeight();
      startAutoplay();
    });
    // Re-measure once the web font is ready — Futura PT metrics change wrapping.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureHeadingHeight);
    }

    return {
      destroy: function () {
        stopAutoplay();
        if (prevBtn) prevBtn.removeEventListener('click', handlePrev);
        if (nextBtn) nextBtn.removeEventListener('click', handleNext);
        dots.forEach(function (dot) {
          dot.removeEventListener('click', handleDotClick);
        });
        allBtns.forEach(function (btn) {
          if (btn) btn.removeEventListener('click', handleItemClick);
        });
        carousel.removeEventListener('pointerenter', pauseAutoplay);
        carousel.removeEventListener('pointerleave', startAutoplay);
        track.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', scheduleMeasure);
        if (ro) ro.disconnect();
        if (scrollRafId !== null) cancelAnimationFrame(scrollRafId);
        if (programmaticScrollTimer !== null) clearTimeout(programmaticScrollTimer);
        if (snapTimer !== null) clearTimeout(snapTimer);
        if (measureTimer !== null) clearTimeout(measureTimer);
        if (headingFadeTimer !== null) clearTimeout(headingFadeTimer);
        if (heading) heading.classList.remove('is-fading');
      }
    };
  }

  var sectionState = new Map();

  function initSection(section) {
    if (!section) return;
    var state = initCarousel(section);
    if (state) {
      sectionState.set(section, state);
    }
  }

  function destroySection(section) {
    if (!section) return;
    var state = sectionState.get(section);
    if (state && typeof state.destroy === 'function') {
      state.destroy();
    }
    sectionState.delete(section);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
